import EnumDTO from "./EnumDTO";

export default class MonitoringDTO {
  constructor(json) {
    if(json) {
      this.id = json.id
      this.timestamp = json.timestamp
      this.submittedFormName = json.submittedForm
      this.email = json.email
      this.formUuid = json.formUuid
      this.statusDto = new EnumDTO(json.status)
      this.remarks = json.remarks
    }
  }

  get status() {
    return this.statusDto.text
  }

  get statusCode() {
    return this.statusDto.code
  }

}

